import { render, staticRenderFns } from "./IconArrowInstagram.vue?vue&type=template&id=731d752d&scoped=true&"
import script from "./IconArrowInstagram.vue?vue&type=script&lang=js&"
export * from "./IconArrowInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731d752d",
  null
  
)

export default component.exports